export default "__VITE_ASSET__Bth4vwIP__"